import { Card, CardBody } from "@chakra-ui/react";
import React from "react";

const DataCard = ({ children, ...props }) => (
  <Card variant={"data"} borderRadius={"20px"} {...props}>
    <CardBody>{children}</CardBody>
  </Card>
);

export default React.memo(DataCard);
